// 场馆管理
export default [{
  path: '/site',
  component: resolve => require(['../pages/siteManage/site.vue'], resolve),
  name: 'site',
  title: "场馆管理",
  meta: {
    title: "场馆管理"
  }
}, {
  path: '/addSite',
  component: resolve => require(['../pages/siteManage/addSite.vue'], resolve),
  name: 'addSite',
  title: "添加场馆",
  meta: {
    title: "添加场馆"
  }
}, {
  path: '/siteInfo',
  component: resolve => require(['../pages/siteManage/siteInfo.vue'], resolve),
  name: 'siteInfo',
  title: "场馆详情",
  meta: {
    title: "场馆详情"
  }
}, {
  path: '/reserve',
  component: resolve => require(['../pages/siteManage/reserve.vue'], resolve),
  name: 'reserve',
  title: "预约管理",
  meta: {
    title: "预约管理"
  }
}, {
  path: '/signIn',
  component: resolve => require(['../pages/siteManage/signIn.vue'], resolve),
  name: 'signIn',
  title: "场馆签到",
  meta: {
    title: "场馆签到"
  }
}, {
  path: '/stadiumOrder',
  component: resolve => require(['../pages/siteManage/stadiumOrder.vue'], resolve),
  name: 'stadiumOrder',
  title: "订单管理",
  meta: {
    title: "订单管理"
  }
},];
